import { QueryProvider } from './providers/QueryProvider'
import { Screen } from './screen'

const RegisterOTP = () => {
  return (
    <QueryProvider>
      <Screen />
    </QueryProvider>
  )
}

export default RegisterOTP
